"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.weekDays = exports.shortWeekDays = exports.dateFormat = exports.monthFormat = exports.yearFormat = void 0;
exports.yearFormat = 'yyyy';
exports.monthFormat = 'MM';
exports.dateFormat = { full: `${exports.yearFormat}-${exports.monthFormat}`, friendly: `MMMM ${exports.yearFormat}` };
exports.shortWeekDays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
exports.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
